
import React, { Component } from 'react';
import {connect} from 'react-redux';
import { Form, Field} from 'react-final-form';
import { CardForm } from '../../widgets/Cards';

import { editAODHistory, newAODHistory, fetchAODHistorys } from '../../../actions';

class AODHistory extends Component {

    constructor(props) {
        super(props);
        this.state = {
            current_entry : null
        };
    };

    componentDidMount() {
        this.props.fetchAODHistorys(this.props.patient._id);
    }

    componentDidUpdate(prevProps) {
        if (this.props.patient._id !== prevProps.patient._id) {
                this.props.fetchAODHistorys(this.props.patient._id)
        }    
    }

    formButton() {
        var permit = this.props.selectedPermission.permission[0].substance;
        if (permit === "View only") {
            return "inaction";
        } else { 
            return "action";
        }  
    }
    
    AODHistoryForm() { 
        const all_contents = this.props.content;
        const last_entry = all_contents[(all_contents.length)-1];
        const content = last_entry;

        const handleSubmit = (formValues) => {
            const form = formValues;

        // Change Actions below
            this.props.newAODHistory(form);
        }

        const required = value =>(value ? undefined : 'Required');

// SECTION A
        return (
            <Form
                onSubmit = {handleSubmit}
                initialValues = {content}
                render = {({handleSubmit, pristine, form, values, submitting}) => {
                    return (
                        <form onSubmit={handleSubmit}>
                            <div className='header'>Drugs and Alcohol History</div>

                            <div className='form-3-columns'>
                                <div>
                                <Field name='abstinence' component='input' validate={required} placeholder='Previous attempts of abstinence and the outcome'>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Abstinence</label>
                                            <textarea cols="80" rows='4' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                <Field name='treatment' component='input' validate={required} placeholder='History of Treatment received'>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Treatment</label>
                                            <textarea cols="80" rows='4' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                <Field name='hospitalisation' component='input' validate={required} placeholder='Hospitalisation'>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Hospitalisation</label>
                                            <textarea cols="80" rows='4' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                </div>
                                <div>
                                <Field name='overdose' component='input' validate={required} placeholder='overdose'>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Overdose</label>
                                            <textarea cols="80" rows='4' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                <Field name='withdrawalsx' component='input' validate={required} placeholder='Withdrawal symptoms/reactions'>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Withdrawal Symptoms</label>
                                            <textarea cols="80" rows='4' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                <Field name='riskyinjecting' component='input' validate={required} placeholder='Any history of risky drug injections'>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Risky Injection Drug Use</label>
                                            <textarea cols="80" rows='4' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                </div>
                                <div>
                                <Field name='usealone' component='input' validate={required} placeholder='Use of substance alone'>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Use of substance alone</label>
                                            <textarea cols="80" rows='4' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                <Field name='drivingintox' component='input' validate={required} placeholder='Driving intoxicated'>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Driving Intoxicated</label>
                                            <textarea cols="80" rows='4' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                </div>
                            </div>

                            <div className={this.formButton()}>
                                <button type='submit' disabled={submitting || pristine} className='btnew'>Submit</button>
                                <button type='button' onClick={form.reset} disabled={submitting || pristine } className='btdel'>Reset</button>
                                <button onClick={() => this.setState({showModal: false, record: null})} className='btdel'>Cancel</button>
                            </div>
                        </form>
                    )
                }}
            />
        )
    }

    render() {
        return (
            <CardForm content={this.AODHistoryForm()}>
            </CardForm>
        )
    }
}


const mapStateToProps = (state) => {

    return { 
             patient : state.selectedPatient,
             content : Object.values(state.aod_historys),
             userId : state.auth.userId,
             selectedPermission : state.selectedPermission,
            };
}

export default connect(mapStateToProps,{editAODHistory, newAODHistory, fetchAODHistorys})(AODHistory);
